export const dataMenusReducer = (state, action) => {
  const { responseData, responseAllViewsData, responseAllMenusData } =
    action.payload;
  state.items = responseData.items;
  state.allItemsView = responseAllViewsData.items;
  state.allItemsMenu = responseAllMenusData.items;
  state.pagination = {
    page: action.meta.arg?.pagina,
    rowsPerPage: action.meta.arg?.itensPorPagina,
    totalPages: responseData.totalPaginas,
    totalItems: responseData.totalRegistros,
  };
  state.requestGetParams = action.meta.arg;
};
